module.exports = __webpack_public_path__ + "static/media/survey_de.f90e89bf.mp4";